import { useCallback } from 'react'
import { bindActionCreators } from 'redux'
import { useSelector, useDispatch } from 'react-redux'

import {
  resultSelector,
  hideOffersAction,
  showMoreOffersAction,
  showAllOffersAction,
} from '@monorepo/deprecated/core/features/SearchEngine'
import { GoodType } from '@monorepo/interfaces'

export function useOffersControl(good: GoodType) {
  const dispatch = useDispatch()
  const {
    data: { showState },
  } = useSelector(resultSelector)

  const showMoreHandler = useCallback(
    bindActionCreators(showMoreOffersAction, dispatch),
    []
  )

  const showAllHandler = useCallback(
    bindActionCreators(showAllOffersAction, dispatch),
    []
  )

  const hideOffers = useCallback(
    bindActionCreators(hideOffersAction, dispatch),
    []
  )

  const expandHandler = useCallback(() => {
    const currentState = showState[good.id]
    if (currentState) {
      showAllHandler(good)
    } else {
      showMoreHandler(good)
    }
  }, [good, showAllHandler, showMoreHandler, showState])

  const collapseHandler = useCallback(() => {
    hideOffers(good)
  }, [good, hideOffers])

  return {
    expandHandler,
    collapseHandler,
  }
}
